import { useState, useEffect } from "react"
import { getContentString } from "../../utils/getContentString"
import { BulkQuestionData, ProcessedQuestionContent } from "./types"

export const useQuestionData = (data: BulkQuestionData) => {
  const [processedContent, setProcessedContent] = useState<
    ProcessedQuestionContent[]
  >([])

  useEffect(() => {
    if (data.documents && data.documents.length > 0) {
      console.log("Processing documents:", {
        documentsLength: data.documents.length,
      })

      const processed = data.documents.map((item) => ({
        ...item,
        solution: item["solution_result"]?.data
          ? getContentString(item["solution_result"].data, 650, {
              imageRenderMode: "auto-size" as const,
              minimizeWhitespace: true,
            })
          : "",
        answer: item["answer_result"]?.data
          ? getContentString(item["answer_result"].data, 650, {
              imageRenderMode: "auto-size" as const,
              minimizeWhitespace: true,
            })
          : "",
        question: item["question_result"]?.data
          ? getContentString(item["question_result"].data, 650, {
              imageRenderMode: "auto-size" as const,
              minimizeWhitespace: true,
            })
          : "",
        subject: data.subject || "",
        topic: data.topic || "",
        topic_id: data.topic_id ?? null,
        complexity: data.complexity || "",
        grade: data.grade || "",
        marking_scheme: item["marking_scheme_result"]?.data
          ? getContentString(item["marking_scheme_result"].data, 650, {
              imageRenderMode: "auto-size" as const,
              minimizeWhitespace: true,
            })
          : "",
        chapter: "",
        chapter_id: null,
        source: "",
        year: "",
        marks: "",
        subPartsText: "",
        sub_parts: [],
        question_status: "published" as const,
      }))

      console.log("Processed content:", processed)
      setProcessedContent(processed)
    } else if (data.documents && data.documents.length === 0) {
      setProcessedContent([])
    }
  }, [
    data.documents,
    data.subject,
    data.topic,
    data.topic_id,
    data.complexity,
    data.grade,
  ])

  const updateContent = (updatedContent: ProcessedQuestionContent[]) => {
    setProcessedContent(updatedContent)
  }

  return {
    processedContent,
    updateContent,
  }
}
